module.exports = __webpack_public_path__ + "media/images/icon_introduction-d7b5ecc9c15e6bafbc725b65eb2cdecb.png";